module.exports = __webpack_public_path__ + "static/media/IMG_7282_DxO.3d1e5fdc.jpg";